/* tslint:disable */
/* eslint-disable */
/**
 * Lendsafe API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
  ApplicationRequest,
  ApplicationResponse,
  LoanDto,
} from '../models';
import {
    ApplicationRequestFromJSON,
    ApplicationRequestToJSON,
    ApplicationResponseFromJSON,
    ApplicationResponseToJSON,
    LoanDtoFromJSON,
    LoanDtoToJSON,
} from '../models';

export interface ApiApprovedGetRequest {
    applicationId?: string | null;
}

export interface ApiCallbackGetRequest {
    applicationId?: string | null;
    accepted?: boolean;
    paidOut?: boolean;
    acceptedAmount?: number | null;
    paidOutVolume?: number | null;
    bank?: string | null;
}

export interface ApiLoansAmountGetRequest {
    amount: number;
}

export interface ApiPostRequest {
    url?: string | null;
}

export interface CreateApplicationRequest {
    loanAmount?: number;
    repaymentPeriod?: number;
    email?: string | null;
    phone?: string | null;
    originReference?: string | null;
    acceptMail?: boolean;
}

export interface PostApplicationRequest {
    applicationRequest: ApplicationRequest;
}

/**
 * 
 */
export class APIApi extends runtime.BaseAPI {

    /**
     */
    async apiAdwordsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/adwords`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAdwordsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdwordsGetRaw(initOverrides);
    }

    /**
     */
    async apiApprovedGetRaw(requestParameters: ApiApprovedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.applicationId !== undefined) {
            queryParameters['applicationId'] = requestParameters.applicationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/approved`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApprovedGet(requestParameters: ApiApprovedGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiApprovedGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiCallbackGetRaw(requestParameters: ApiCallbackGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.applicationId !== undefined) {
            queryParameters['ApplicationId'] = requestParameters.applicationId;
        }

        if (requestParameters.accepted !== undefined) {
            queryParameters['Accepted'] = requestParameters.accepted;
        }

        if (requestParameters.paidOut !== undefined) {
            queryParameters['PaidOut'] = requestParameters.paidOut;
        }

        if (requestParameters.acceptedAmount !== undefined) {
            queryParameters['AcceptedAmount'] = requestParameters.acceptedAmount;
        }

        if (requestParameters.paidOutVolume !== undefined) {
            queryParameters['PaidOutVolume'] = requestParameters.paidOutVolume;
        }

        if (requestParameters.bank !== undefined) {
            queryParameters['Bank'] = requestParameters.bank;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiCallbackGet(requestParameters: ApiCallbackGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiCallbackGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiLoansAmountGetRaw(requestParameters: ApiLoansAmountGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LoanDto>>> {
        if (requestParameters.amount === null || requestParameters.amount === undefined) {
            throw new runtime.RequiredError('amount','Required parameter requestParameters.amount was null or undefined when calling apiLoansAmountGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/loans/{amount}`.replace(`{${"amount"}}`, encodeURIComponent(String(requestParameters.amount))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LoanDtoFromJSON));
    }

    /**
     */
    async apiLoansAmountGet(requestParameters: ApiLoansAmountGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LoanDto>> {
        const response = await this.apiLoansAmountGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiLoansGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LoanDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/loans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LoanDtoFromJSON));
    }

    /**
     */
    async apiLoansGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LoanDto>> {
        const response = await this.apiLoansGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPostRaw(requestParameters: ApiPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.url !== undefined) {
            queryParameters['url'] = requestParameters.url;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiPost(requestParameters: ApiPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiSetDeclinedGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/setDeclined`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSetDeclinedGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiSetDeclinedGetRaw(initOverrides);
    }

    /**
     */
    async createApplicationRaw(requestParameters: CreateApplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.loanAmount !== undefined) {
            queryParameters['loanAmount'] = requestParameters.loanAmount;
        }

        if (requestParameters.repaymentPeriod !== undefined) {
            queryParameters['repaymentPeriod'] = requestParameters.repaymentPeriod;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.phone !== undefined) {
            queryParameters['phone'] = requestParameters.phone;
        }

        if (requestParameters.originReference !== undefined) {
            queryParameters['originReference'] = requestParameters.originReference;
        }

        if (requestParameters.acceptMail !== undefined) {
            queryParameters['acceptMail'] = requestParameters.acceptMail;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/createApplication`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async createApplication(requestParameters: CreateApplicationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createApplicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postApplicationRaw(requestParameters: PostApplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationResponse>> {
        if (requestParameters.applicationRequest === null || requestParameters.applicationRequest === undefined) {
            throw new runtime.RequiredError('applicationRequest','Required parameter requestParameters.applicationRequest was null or undefined when calling postApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/api/application`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationRequestToJSON(requestParameters.applicationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationResponseFromJSON(jsonValue));
    }

    /**
     */
    async postApplication(requestParameters: PostApplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationResponse> {
        const response = await this.postApplicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
